import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { config } from '../../utils/config';

import NProgress from '../NProgress';
import PublicRoute from './PublicRoute';
import Gondola from '../../containers/Gondola/Gondola';

// Pages
// Campania DELIA: pagina de index este landing page-ul campaniei.
// Fluxul vechi (PageRouter) rămâne în cod, dar nu mai este rutat.
const CampaignLP = lazy(() => import('../../containers/CampaignLP'));
const Teasing = lazy(() => import('../../containers/Teasing'));
const Experiente = lazy(() => import('../../containers/Experiente'));

// Misc pages
const NotFound = lazy(() => import('../../containers/NotFound'));

const Router = () => {
    return (
        <Suspense fallback={<NProgress />}>
            <Routes>
                {/*
                    Landing page-ul campaniei este public pentru toată lumea, deci nu este
                    împachetat în PublicRoute: acela redirecționează către config.path.index,
                    ceea ce ar produce o buclă de redirect chiar pe ruta de index.
                */}
                <Route path={config.path.index} element={<CampaignLP />} />
                <Route
                    path={'/experiente'}
                    element={
                        <PublicRoute>
                            <Experiente />
                        </PublicRoute>
                    }
                />
                <Route
                    path={config.path.teasing}
                    element={
                        <PublicRoute>
                            <Teasing />
                        </PublicRoute>
                    }
                />
                <Route path={config.path.error} element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    );
};

export default Router;
